'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NextAnimate = require('./NextAnimate');

var _NextAnimate2 = _interopRequireDefault(_NextAnimate);

var _nextUtilNew = require('./next-util-new');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

var Expand = function (_Component) {
    (0, _inherits3.default)(Expand, _Component);

    function Expand(props) {
        (0, _classCallCheck3.default)(this, Expand);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Expand.__proto__ || (0, _getPrototypeOf2.default)(Expand)).call(this, props));

        (0, _nextUtilNew.bindCtx)(_this, ['beforeEnter', 'onEnter', 'afterEnter', 'beforeLeave', 'onLeave', 'afterLeave']);
        return _this;
    }

    (0, _createClass3.default)(Expand, [{
        key: 'beforeEnter',
        value: function beforeEnter(node) {
            this.styleHeight = node.style.height;
            this.height = node.offsetHeight;
            node.style.height = '0px';
            this.props.beforeEnter(node);
        }
    }, {
        key: 'onEnter',
        value: function onEnter(node) {
            node.style.height = this.height + 'px';
            this.props.onEnter(node);
        }
    }, {
        key: 'afterEnter',
        value: function afterEnter(node) {
            this.height = null;
            node.style.height = this.styleHeight;
            this.props.afterEnter(node);
        }
    }, {
        key: 'beforeLeave',
        value: function beforeLeave(node) {
            node.style.height = node.offsetHeight + 'px';
            this.props.beforeLeave(node);
        }
    }, {
        key: 'onLeave',
        value: function onLeave(node) {
            node.style.height = '0px';
            this.props.onLeave(node);
        }
    }, {
        key: 'afterLeave',
        value: function afterLeave(node) {
            this.props.afterLeave(node);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                animation = _props.animation,
                others = (0, _objectWithoutProperties3.default)(_props, ['animation']);

            var newAnimation = animation || 'expand';

            return _react2.default.createElement(_NextAnimate2.default, (0, _extends3.default)({}, others, {
                animation: newAnimation,
                beforeEnter: this.beforeEnter,
                onEnter: this.onEnter,
                afterEnter: this.afterEnter,
                beforeLeave: this.beforeLeave,
                onLeave: this.onLeave,
                afterLeave: this.afterLeave }));
        }
    }]);
    return Expand;
}(_react.Component);

Expand.propTypes = {
    animation: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    beforeEnter: _propTypes2.default.func,
    onEnter: _propTypes2.default.func,
    afterEnter: _propTypes2.default.func,
    beforeLeave: _propTypes2.default.func,
    onLeave: _propTypes2.default.func,
    afterLeave: _propTypes2.default.func
};
Expand.defaultProps = {
    beforeEnter: noop,
    onEnter: noop,
    afterEnter: noop,
    beforeLeave: noop,
    onLeave: noop,
    afterLeave: noop
};
exports.default = Expand;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-slider-bar-nav@0.0.38@@alicd/crui-slider-bar-nav/lib/NextExpand.js
// module id = 741
// module chunks = 0